import React from "react";

import Button from "@common/components/Button/Button";
import { ModalProps } from "@common/components/Modal/Modal";
import { ModalHeaderProps } from "@common/components/Modal/ModalHeader/ModalHeader";

interface Props {
  deleteApiKey: () => void;
  loading: boolean;
  Modal: React.ForwardRefExoticComponent<ModalProps & ModalHeaderProps & React.RefAttributes<unknown>>;
  internalProps?: ModalProps;
  subtitle?: string;
}

export default function DeleteDomainModalBody({ deleteApiKey, loading, Modal, internalProps, subtitle }: Props) {
  const handleDeleteApiKey = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.preventDefault();
    deleteApiKey();
  };

  return (
    <Modal
      {...internalProps}
      heading={"Are you sure?"}
      subtitle={subtitle || "This will permanently delete the Domain. This action in irreversible."}
      buttonElement={
        <Button
          type="button"
          size="small"
          color="red"
          disabled={loading}
          loadingText={loading && "Deleting..."}
          onClick={(e) => handleDeleteApiKey(e)}
        >
          Delete
        </Button>
      }
    ></Modal>
  );
}
